import type { IServicesCollection } from 'src/packages/di';

import type { IAuthService } from './AuthStore';
import { AuthService, authStore } from './AuthStore';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    authService: IAuthService;
  }
}

export function addAuthService(di: IServicesCollection): void {
  if (!authStore.userInfo) {
    return;
  }

  di.addSingleton('authService', new AuthService(authStore));
}
